module.exports = __webpack_public_path__ + "img/edit_button.16f59ea4.svg";